export default __webpack_public_path__ + "static/media/16t.1871325b.jpg";